import React from 'react';
import { Link } from 'react-router-dom';

import '../../App.css';
import { useLanguage } from '../../contexts/LanguageContext';
import { t } from '../../translations';
import KitchenCarousel from '../KitchenCarousel';
import CourtyardCarousel from '../CourtyardCarousel';
import HayloftCarousel from '../HayloftCarousel';
import RecordingStudioHireCarousel from '../RecordingStudioHireCarousel';

function HirePage() {
  const { language } = useLanguage();

  return (
    <div className="page hire-page">
      {/* Full width intro panel */}
      <div className="full-width-text-panel" >

        <p>
          {t('hire.intro', language)}
        </p>

      </div>
      {/* Kitchen carousel and text */}
      <div className="halftone-bg xfade-section"><KitchenCarousel /></div>
      <div className="full-width-text-panel" style={{textAlign: 'center'}}>
        <h3 style={{fontSize: '1.4rem', marginBottom: '1rem', fontFamily: 'Jost, sans-serif'}}>{t('hire.kitchenTitle', language)}</h3>
        <p>
          {t('hire.kitchenDesc', language)}
        </p>
      </div>

      {/* Courtyard carousel and text */}
      <div className="halftone-bg xfade-section"><CourtyardCarousel /></div>
      <div className="full-width-text-panel" style={{textAlign: 'center'}}>
        <h3 style={{fontSize: '1.4rem', marginBottom: '1rem', fontFamily: 'Jost, sans-serif'}}>{t('hire.courtyardTitle', language)}</h3>
        <p>
          {t('hire.courtyardDesc', language)}
        </p>
      </div>

      {/* Hayloft carousel and text */}
      <div className="halftone-bg xfade-section"><HayloftCarousel /></div>
      <div className="full-width-text-panel" style={{textAlign: 'center'}}>
        <h3 style={{fontSize: '1.4rem', marginBottom: '1rem', fontFamily: 'Jost, sans-serif'}}>{t('hire.hayloftTitle', language)}</h3>
        <p>
          {t('hire.hayloftDesc', language)}
        </p>
      </div>

      {/* Studio carousel and text */}
      <div className="halftone-bg xfade-section"><RecordingStudioHireCarousel /></div>
      <div className="full-width-text-panel" style={{textAlign: 'center'}}>
        <h3 style={{fontSize: '1.4rem', marginBottom: '1rem', fontFamily: 'Jost, sans-serif'}}>{t('hire.studioTitle', language)}</h3>
        <p>
          {t('hire.studioDesc', language)}
        </p>
      </div>

      {/* Pink collaboration panel with Book Now button */}
      <div className="collaboration-panel">

        <Link to="/contact" className="book-now-btn" style={{fontFamily: 'Jost, sans-serif'}}>
          {t('hire.bookNow', language)}
        </Link>
      </div>
    </div>
  );
}

export default HirePage;
